export default __webpack_public_path__ + "static/media/facebook.6e8bd697.svg";